import { MapProvider } from 'geo-three';
// 'https://mo44-45.mnl.gov.hu/mapserver/1941/tiles.php/
export class MapsProvider extends MapProvider {
	constructor(address = 'https://mapserver.vektorlab.hu/1941/tiles.php', depth = false) {
		super();
		this.address = address;
		this.depth = depth;
		this.minZoom = 8;
	}

	fetchTile(zoom, x, y) {
		return new Promise((resolve, reject) => {
			const img = new Image();
			img.crossOrigin = 'Anonymous';

			const depthFlag = this.depth ? '&depth=true' : '';
			img.src = `${this.address}?z=${zoom}&x=${x}&y=${y}${depthFlag}`;

			img.onload = () => resolve(img);
			img.onerror = reject;
		});
	}
}
